import React, { useState } from "react";
import "./Navbar.css";
import { Zap } from "lucide-react";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <>
      <nav className="nav-wrapper">
        <div className="navbar">

          {/* LEFT */}
          <div className="nav-left">
            <div className="logo-circle">
              <Zap size={20} color="white" />
            </div>
            <span className="logo-text">Sharp Design</span>
          </div>

          {/* CENTER (desktop) */}
          <ul className="nav-center">
            <li><a href="#album">Album</a></li>
            <li><a href="#covers">Covers</a></li>
            <li><a href="#servicios">Servicios</a></li>
            <li><a href="#bio-section">Sobre mi</a></li>
          </ul>

          {/* RIGHT */}
          <div className="nav-right">
            <div className="divider"></div>

            <a
              href="https://wa.me/584242603751?text=Hola%20quiero%20información%20sobre%20tus%20servicios"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-btn"
            >
              <span className="status-dot"></span>
              Contactame
            </a>

            {/* HAMBURGER MOBILE */}
            <div className="mobile-menu-btn" onClick={toggleMenu}>
              <span className={menuOpen ? "line line1 open" : "line"}></span>
              <span className={menuOpen ? "line line2 open" : "line"}></span>
            </div>
          </div>

        </div>
      </nav>

      {/* MOBILE DROPDOWN MENU */}
      <div className={menuOpen ? "mobile-menu show" : "mobile-menu"}>
        <a href="#album" onClick={toggleMenu}>Album</a>
        <a href="#covers" onClick={toggleMenu}>Covers</a>
        <a href="#servicios" onClick={toggleMenu}>Servicios</a>
        <a href="#bio-section" onClick={toggleMenu}>Sobre mi</a>

        <div className="mobile-divider"></div>

        <a
          href="https://wa.me/584242603751?text=Hola%20quiero%20información%20sobre%20tus%20servicios"
          target="_blank"
          rel="noopener noreferrer"
          className="mobile-contact"
        >
          Contactame
        </a>
      </div>
    </>
  );
}
